<template>
  <div class="wrapper">
    <div>
      <span>DATOS DE NAVISION</span>
      <span id="total">Total: {{ count }}</span>
    </div>
    <br />
    <div>
      <div class="table-container">
        <el-table :data="Data" style="width: 100%" class="Tabla" height="400">
          <el-table-column
            prop="Descripcion"
            label="Descripcion"
            minWidth:150
          ></el-table-column>

          <el-table-column label="No_ Serie" prop="Serie">
            <template slot-scope="scope">
              <el-select
                v-model="cliente[scope.$index]"
                :placeholder="
                  scope.row.Serie != '' || undefined
                    ? scope.row.Serie
                    : 'producto'
                "
                :disabled="scope.row.Serie != '' || undefined ? Enable : false"
                filterable
                clearable
                @clear="HandlerClear(scope)"
                @change="handlerChange(scope)"
              >
                <el-option
                  v-for="item in Productos"
                  :key="item.ID"
                  :label="item.Name"
                  :value="item.ID"
                />
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navyxion",
  props: {
    Cliente: String,
    Productos: [],
    DataSave: Function,
    Enables: Boolean,
    TabChange: String
  },
  data() {
    return {
      isLoading: false,
      count: 0,
      Data: [],
      cliente: [],
      producto: [],
      SaveData: [],
      Enable: true
    };
  },

  methods: {
    async getData(value) {
      this.Data = [];
      this.isLoading = true;
      await this.$http
        .get(`/api/customers/GetContractLineByCliente?Cliente=${value}`)
        .then(({ data }) => {
          this.count = data.total;
          data.resultado.forEach((element) => {
            this.Data.push({
              Descripcion: element.Descripcion,
              Serie: element.Serie
            });
          });
        });
      this.producto = [...this.Productos];

      this.ProductSelected(this.Data, this.Productos);

      this.isLoading = false;
    },

    ProductSelected(Items, Productos) {
      let values = Items.filter((element) =>
        Productos.map((value) => value.ID).includes(parseInt(element.Serie))
      );
      values.forEach((element) => {
        let index = Productos.findIndex((x) => x.ID == element.Serie);
        this.Productos.splice(index, 1);
      });
    },

    pushData(val, values) {
      let index = this.SaveData.findIndex(
        ({ Descripcion }) => Descripcion == val.row.Descripcion
      );
      this.Productos.push({
        ID: values.ID,
        Name: values.Name
      });
      this.SaveData.splice(index, 1);
    },

    handlerChange(val) {
      if (this.cliente[val.$index] != "") {
        let ID = this.SaveData.find(
          (x) => x.Descripcion == val.row.Descripcion
        );

        if (ID) {
          let values = this.producto.find(
            (elemento) => elemento.ID == ID.Serie
          );
          this.pushData(val, values);
        }
        let index = this.Productos.findIndex(
          (x) => x.ID == this.cliente[val.$index]
        );

        this.SaveData.push({
          Descripcion: val.row.Descripcion,
          Serie: this.Productos[index].ID,
          cliente: this.Cliente
        });
        this.Productos.splice(index, 1);
      }
    },

    HandlerClear(val) {
      let ID = this.SaveData.find(
        ({ Descripcion }) => Descripcion == val.row.Descripcion
      );
      let values = this.producto.find((elemento) => elemento.ID == ID.Serie);
      this.pushData(val, values);
    }
  },

  watch: {
    TabChange() {
      this.Data = [];
    },
    async Cliente() {
      if (this.Cliente != "") {
        await this.getData(this.Cliente);
      }
    },
    async DataSave() {
      if (this.DataSave) {
        await this.$emit("Guardar-Datos", this.SaveData);
      } else {
        this.cliente = [];
        await this.getData(this.Cliente);
      }
    },
    Enables() {
      this.Enable = this.Enables;
    }
  }
};
</script>

<style>
.Table {
  margin: 0 auto;
  padding-left: 200px;
}
.Tabla {
  margin: 0 auto;
  /* padding-left: 200px; */
}
.table-container {
  margin: 0 auto;
}
#total {
  float: right;
}
</style>
